import React, { useEffect, useState } from "react";
import { list, remove } from "../../../services/wishlistService";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

export default function WishlistTab() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const load = () => {
    setLoading(true);
    const r = list();
    setRows(Array.isArray(r) ? r : []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const removeOne = (codArt) => {
    remove(codArt);
    load();
    toast.info("Retiré de la liste de souhaits");
  };

  return (
    <section className="acc-panel">
      <h2 className="acc-title">Liste de souhaits</h2>

      {loading ? (
        <div className="skel skel-line" />
      ) : rows.length === 0 ? (
        <div className="acc-empty">Votre liste est vide.</div>
      ) : (
        <ul className="acc-wish">
          {rows.map(p => (
            <li key={p.codArt} className="acc-wishItem">
              <div className="acc-wishInfo">
                <div className="acc-wishThumb">
                  {p.image ? <img src={p.image} alt={p.name} /> : <div className="thumbPh" />}
                </div>
                <div>
                  <div className="acc-wishName">{p.name}</div>
                  <div className="acc-wishCode">[{p.codArt}]</div>
                </div>
              </div>

              <div className="acc-wishRight">
                <div className="acc-wishPrice">
                  {typeof p.price === "number" ? p.price.toFixed(3) + " DT" : "—"}
                </div>

                <div className="acc-wishBtns">
                  <Link
                    className="acc-linkBtn"
                    to={p.link || `/produits/${encodeURIComponent(p.codArt)}`}
                    state={{ item: p.rawItem || null }}

                  >
                    Voir
                  </Link>


                  <button className="acc-linkBtn danger" onClick={() => removeOne(p.codArt)}>
                    Retirer
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
